import { createSlice } from '@reduxjs/toolkit';

// --------------- Helpers --------------------------

const _getStorageData = () => {
	let res =  false;
	let js = {};
	if (typeof(Storage) !== "undefined") {
		let storage_keys_check_n = ["uid","pwd"].reduce(
			(previous, k) => {
				if ( 
					window.localStorage.getItem(k) !== null &&
					window.localStorage.getItem(k).length > 0
				) {
					return previous + 1;
				} else {
					return 0;
				}
			},
			0
		);
		if ( storage_keys_check_n === 2 ) {
			res = true;
			js["uid"] = window.localStorage.getItem("uid");
			js["pwd"] = window.localStorage.getItem("pwd");
		} else {
			res = false;
		}
	} else {
		res = false;
	}
	return [res, js];
}

const _getSearchParams = () => {
	let res =  false;
	let js = {};
	const searchParamsIterator = new URLSearchParams(window.location.search);
	const search_params_n = Array.from([...searchParamsIterator.keys()]).length
	if ( search_params_n > 0 ) {
		res = true;
		let search_params_js = Object.fromEntries(searchParamsIterator);
		Object.keys(search_params_js).forEach( k => {
			search_params_js[k] = Buffer
									.from(search_params_js[k], 'base64')
									.toString("utf-8")

		} )
		js = {...search_params_js}
	}
	return [res, js];
}

// --------------------------------------------------

export const appStates = createSlice({
	
	name: "appStates",

	initialState: {
		url: window.location.origin + window.location.pathname,
		current_page: undefined,
		current_page_props: {},
		storage_data_js: undefined,
		search_params_js: undefined
	},
	
	// to send data to these:
	// use useDispatch()
	// or
	// store.dispatch({type: "myName/myReducer",payload: {...}}); 

	reducers: {

		init: (state, action) => {
			// Requirements: 
			//	{page: 'ABC', props: {...}}
			let js = action.payload;
			
			state.current_page = js.page;

			if ( js.props === undefined ) {
				state.current_page_props = {};
			} else {
				state.current_page_props = js.props;
			}
			
			let [ is_storage_data_bool, storage_data_js ] = _getStorageData();
			if ( is_storage_data_bool ) {
				state.storage_data_js =  storage_data_js;
			} else {
				state.storage_data_js =  null;
			}

			let [ is_search_params_bool, search_params_js ] = _getSearchParams();
			if ( is_search_params_bool ) {
				state.search_params_js =  search_params_js;
			} else {
				state.search_params_js =  null;
			}


		},
		
		setAppPage: (state, action) => {
			let js = action.payload;
			
			state.current_page = js.page;
			if ( js.props === undefined ) {
				state.current_page_props = {};
			} else {
				state.current_page_props = js.props;
			}
			
		},

		setAppState: (state, action) => {
			let js = action.payload;

			let id = js.id;
			let uid = js.uid;

			state[id] = uid;
		},

		resetStorageData: (state, action = {}) => {
			
			let js = action.payload; 

			if ( js.reload_bool ) {
				let [ is_storage_data_bool, storage_data_js ] = _getStorageData();
				if ( is_storage_data_bool ) {
					state.storage_data_js =  storage_data_js;
				} else {
					state.storage_data_js =  null;
				}
			} else {
				state.storage_data_js =  null;
				window.localStorage.clear();
			}

		},

		resetSearchParamsData: (state, action = {}) => {
			state.search_params_js =  null;
		}

	}

});

export const {
	initAppState,
	setAppPage,
	setAppState,
	resetStorageData,
	resetSearchParamsData
} = appStates.actions;

// const url = useSelector( (state) => getUrl(state) )
export const getUrl = (state) => {
	return state.appStates.url;
}

export const getCurrentPage = (state) => {
	let res;
	if ( state.appStates.current_page === undefined ) {
		res = "none";
	} else {
		res = state.appStates.current_page;
	}
	return res;
}

export const getCurrentPageProps = (state) => {
	let res;
	if ( state.appStates.current_page_props === undefined ) {
		res = {};
	} else {
		res = state.appStates.current_page_props;
	}
	return res;
}

// const storage_data_js = useSelector( (state) => getStorageData(state) )
export const getStorageData = (state) => {
	let res;
	if ( state.appStates.storage_data_js === undefined ) {
		res = null;
	} else {
		if ( state.appStates.storage_data_js === null ) {
			res = null;
		} else {
			res = state.appStates.storage_data_js;
		}
	}
	return res;
}


// const search_params_js = useSelector( (state) => getSearchParamsData(state) )
export const getSearchParamsData = (state) => {
	let res;
	if ( state.appStates.search_params_js === undefined ) {
		res = null;
	} else {
		if ( state.appStates.search_params_js === null ) {
			res = null;
		} else {
			res = state.appStates.search_params_js;
		}
	}
	return res;
}

export const getAppStates = (state) => {
	return state.appStates;
}


export default appStates.reducer;